var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthCheckup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4165_8448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2656 23.5312H4.73438C3.95775 23.5312 3.32812 22.9016 3.32812 22.125V1.875C3.32812 1.09837 3.95775 0.46875 4.73438 0.46875H19.2656C20.0423 0.46875 20.6719 1.09837 20.6719 1.875V22.125C20.6719 22.9016 20.0423 23.5312 19.2656 23.5312Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5156 2.34375H15.4787C15.3378 2.93508 14.8064 3.375 14.1719 3.375H9.82809C9.19359 3.375 8.66217 2.93508 8.52127 2.34375H8.48438H5.20312V21.6562H18.7969V2.34375H15.5156Z",
    fill: "#EAE8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5781 7.35938H12.9375V5.71875H11.0625V7.35938H9.42188V9.23438H11.0625V10.875H12.9375V9.23438H14.5781V7.35938Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3594 13.2188H7.54688V15.0938H10.3594V13.2188Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 15.0938H16.4531",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 13.2188H16.4531",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3594 17.4375H7.54688V19.3125H10.3594V17.4375Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 19.3125H16.4531",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 17.4375H16.4531",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1719 3.375H9.82809C9.08597 3.375 8.48438 2.77341 8.48438 2.03128V0.46875H15.5156V2.03128C15.5156 2.77341 14.914 3.375 14.1719 3.375Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4165_8448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCheckup);
export default __webpack_public_path__ + "static/media/health_checkup.8f26e582a35f9eae70c21fb2ebf65820.svg";
export { ForwardRef as ReactComponent };